import React, { useState } from 'react'
import usePresentPage from 'client/hooks/usePresentPage'
import { getPageType } from 'client/reducers/pageReducer'
import { Blocks } from '../blocks'
import { Elements } from '../elements'
import { Switcher } from 'src/editor/shared/ui-lib/switcher'

const sidebarModes = {
  elements: 'elements',
  blocks: 'blocks',
  // layers: 'layers',
} as const

type SidebarMode = keyof typeof sidebarModes

export const Library = () => {
  const [mode, setMode] = useState<SidebarMode>(sidebarModes.elements)
  const pageType = usePresentPage(getPageType)

  return (
    <>
      <Switcher
        btnList={[
          {
            value: sidebarModes.elements,
            content: 'components.core.toolbox.types.elements',
          },
          {
            value: sidebarModes.blocks,
            content: 'components.core.toolbox.types.blocks',
          },
        ]}
        value={mode}
        update={setMode}
        wrapperClassName="p-0 mb-5"
      />

      <div>
        {mode === sidebarModes.elements ? (
          <Elements pageType={pageType} />
        ) : (
          <Blocks pageType={pageType} />
        )}
      </div>
    </>
  )
}
